
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#56BFC7","clip-path":"url(#clip0_25988_5546)"}},[_c('path',{attrs:{"d":"M16.122.175a2.572 2.572 0 012.108.674l.02.018 5.502 5.503.018.02a2.57 2.57 0 01-.528 3.952l-5.308 3.425-1.74 7.292a1.904 1.904 0 01-3.152.906L2.49 11.395a1.886 1.886 0 01.912-3.143l.016-.004 7.362-1.64 3.502-5.237a2.572 2.572 0 011.84-1.196zm.608 1.731a.857.857 0 00-1.014.404l-3.703 5.537a.857.857 0 01-.526.36L3.8 9.92a.171.171 0 00-.081.282l10.514 10.531a.19.19 0 00.298-.097l1.815-7.6a.857.857 0 01.368-.522l5.626-3.63a.856.856 0 00.188-1.312l-5.481-5.48a.858.858 0 00-.318-.185z"}}),_c('path',{attrs:{"d":"M8.972 15.59a.857.857 0 01.005 1.213l-7.012 7.063A.857.857 0 11.75 22.658l7.011-7.063a.857.857 0 011.212-.004z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25988_5546"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .12)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    